import React, { FC, FocusEventHandler, MouseEventHandler, useCallback, useState } from 'react';

import InputWithAnalytics from 'app/widgets/InputsWithAnalytics/Input';

import { type InputProps } from './index';

type PasswordIconProps = {
  onIconBlur?: FocusEventHandler;
  onIconFocus?: FocusEventHandler;
};

export type PasswordInputProps = Omit<
  InputProps,
  'iconLeft' | 'iconRight' |
  'iconLeftProps' | 'iconRightProps'
> & {
  customInput?: typeof InputWithAnalytics;
};

const PasswordInput: FC<PasswordInputProps & PasswordIconProps> = ({
  onIconBlur,
  onIconFocus,
  customInput: InputComponent = InputWithAnalytics,
  ...props
}) => {
  const [isShowingPassword, setIsShowingPassword] = useState(false);

  const handleIconClick = useCallback<MouseEventHandler>((event) => {
    event.preventDefault();
    setIsShowingPassword(!isShowingPassword);
  }, [isShowingPassword]);

  return (
    <InputComponent
      {...props}
      maxLength={50}
      type={isShowingPassword ? 'text' : 'password'}
      iconRight={isShowingPassword ? 'eye' : 'eye-slash'}
      className={props.className}
      iconRightProps={{
        name: 'password-icon',
        onClick: handleIconClick,
        onBlur: onIconBlur,
        onFocus: onIconFocus,
      }} />
  );
};

export default PasswordInput;
